const routes = {
  restaurantGroup: 'restaurant-group',
  containers: {},
};

export default routes;
